import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SignupuserService } from '../../../services/signupuser.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service'

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FormsModule, CommonModule, NgxSpinnerModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
  providers: [NgxSpinnerModule]
})
export class ForgotPasswordComponent {
  emailaddress: any;
  language: any = 'en';
  hostname: any = window.location.origin;
  // token: string;
  // auth: string;
  IsForgotPassword: boolean = false;
  IsChangePassword: boolean = false;
  IsSendForgotPasswordLink: boolean = false;
  Password: any;
  Retypepassword: any;
  ChangePasswordDetails:any;
  IsValidPassword: boolean = false;
  IsSyngentaEmail: boolean = false;
  showEmailErr: boolean = false;
  showEmailMsg: any;

  constructor(private userService: SignupuserService, private route: Router, private spinner: NgxSpinnerService, private authService: AuthService) { }

  ngOnInit() {
    this.authService.checkAuthAndRedirectHome();
  }
  validateUser(){

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(this.emailaddress);
    let checkSyngentaUser = this.emailaddress.includes('syngenta');   
    if(this.emailaddress === '' && !valid){
      this.showEmailErr = true;
      this.showEmailMsg = "Please enter email address.";
    } else if(this.emailaddress !== '' && !valid){
      this.showEmailErr = true;
      this.showEmailMsg = "Please enter a valid email address.";
    } else {
       if(checkSyngentaUser === true){
        this.showEmailErr = true;
        this.showEmailMsg = "Please use Syngenta password to login.";
       } else{
        this.showEmailErr = false;
        this.showEmailMsg = "";
       }
    }
  }
  submitForm() {
    if (this.emailaddress.length > 0) {
      this.spinner.show()
      let userDetails = {
            Website: "SSP",
            Email: this.emailaddress,
            AppType: ""
      }
      //To check if the email is valid/not using UserAPI
      this.userService.validatemail(this.emailaddress).subscribe(res => {
        // console.log(res);
        if (res.Status.toLowerCase() !== "invalid") {
          this.showEmailErr = false; 
          /*Checking Syngenta User*/
          let checkSyngentaUser = this.emailaddress.includes('syngenta');
          // console.log(checkSyngentaUser);
              if(checkSyngentaUser === true){
                // console.log("Syngenta Users");
                this.spinner.hide();
                this.showEmailErr = true;
                this.showEmailMsg = "Please use Syngenta password to login.";
              } else{
          //Since the Email is valid sending password reset mail to user
          this.userService.forgotPassword(userDetails).subscribe((res: any) => { 
            if (res && res.Status.toLowerCase() === 'success') {
              this.IsSendForgotPasswordLink = true;
              // console.log("Email successfully sent");
              this.spinner.hide();
            } else if(res && res.Status ==='Invalid user'){
              this.showEmailErr = true;
              this.showEmailMsg = "Entered email address is not registered to Storen Satisfaction Program account.";
              this.spinner.hide();
            }
            else {
              this.spinner.hide()
              // console.log("forgot pass Email not sent");
              this.showEmailErr = true;
              this.showEmailMsg = 'Oops! Something went wrong. Please try again later.';
            }
          });
        }
        } else {
          this.spinner.hide()
          this.showEmailErr = true;
          this.showEmailMsg = 'Please enter a valid email address';
        }
      });
    } 
  }
  redirectToLogin() {
    this.route.navigateByUrl('/log-in');
  }
}
